<template>
  <div class="pages">
    <el-breadcrumb separator-class="el-icon-arrow-right">
      <el-breadcrumb-item >位置：</el-breadcrumb-item>
      <el-breadcrumb-item>产品列表</el-breadcrumb-item>
    </el-breadcrumb>
    <div class="main">
        <div class="main_filter">
            <div>
              <div>
                <el-input v-model="data.product_name" placeholder="请输入关键字" clearable  />
              </div>
              <div>
                <el-select v-model="data.type_id"  placeholder="全部分类" clearable>
                  <el-option
                    v-for="item in typeArr"
                    :key="item.id"
                    :label="item.type_name"
                    :value="item.id"
                  ></el-option>
                </el-select>
              </div>
              <div>
                <el-select v-model="data.state"  placeholder="全部状态" clearable>
                  <el-option
                    v-for="item in option"
                    :key="item.value"
                    :label="item.label"
                    :value="item.value"
                  ></el-option>
                </el-select>
              </div>
              <div class="filter_btns">
                <div @click="chaxun">查询</div>
              </div>
            </div>
            <div>
              <!-- <div>
                <img src="@/assets/paixu.png" alt="" style="width:1.4rem;height:1rem;">
                <span>排序</span>
              </div> -->
              <div @click="addProClick"> 
                <img src="@/assets/adds.png" alt="" style="width:1.4rem;height:1.4rem;">
                <span>添加产品</span>
              </div>
            </div>
        </div>
        <el-table
        ref="multipleTable"
        :data="tableData"
        tooltip-effect="dark"
        style="width: 100%"
        :header-cell-style="tableHeaderColor"
        @selection-change="handleSelectionChange"
        :cell-style="cellStyle"
        :row-class-name="tableRowClassName"
        >
          <el-table-column
            type="selection"
            width="55">
          </el-table-column>
          <el-table-column prop="sort" label="排序" width="80">
            <template slot-scope="scope">
              <el-input v-model="scope.row.sort" @blur="sortBlur(scope.row)" ></el-input>
            </template>
          </el-table-column>
          <el-table-column prop="id" label="产品ID" width="166"></el-table-column>
          <el-table-column  label="产品名称" >
            <template slot-scope="scope">
              <div class="product_divs">
                <img src="@/assets/guoqi.png" alt="" v-if="!ProDetaik(scope.row)">
                <div :class="ProDetaik(scope.row)==true?'':'lg_css'">
                  {{scope.row.product_name}}
                </div>
              </div>
            </template>
          </el-table-column>
          <el-table-column prop="price" label="销售期限" width="330">
            <template slot-scope="scope">
              {{scope.row.sell_start}}-{{scope.row.sell_end}}
            </template>
          </el-table-column>
          <el-table-column prop="sellnum" label="已售" width="100">
          </el-table-column>
          <el-table-column prop="refundnum" label="退货" width="100">
          </el-table-column>
          <el-table-column  label="状态" width="100">
            <template  slot-scope="scope">
              <div class="flex_tui" v-if="scope.row.state=='1'" >
                <img src="@/assets/dl.png" alt />
                <span style="margin-left:9px">上线</span>
              </div>
              <div class="flex_tui" v-if="scope.row.state=='2'" >
                <img src="@/assets/dh.png" alt />
                <span style="margin-left:9px">下线</span>
              </div>
            </template>
          </el-table-column>
          <el-table-column prop="ProductID" label="可退" width="124">
            <template  slot-scope="scope">
              <div class="flex_tui" v-if="scope.row.refund_flag=='1'">
                <img src="@/assets/dl.png" alt />
                <span style="margin-left:9px">可退</span>
              </div>
              <div class="flex_tui"  v-if="scope.row.refund_flag=='2'">
                <img src="@/assets/dh.png" alt />
                <span style="margin-left:9px">不可退</span>
              </div>
              <div class="flex_tui"  v-if="scope.row.refund_flag=='3'">
                <img src="@/assets/dh.png" alt />
                <span style="margin-left:9px">仅退款</span>
              </div>
            </template>
          </el-table-column>
          <el-table-column prop="ProductID" label="操作" width="200"    fixed="right">
              <template slot-scope="scope">
                <span class="color_btns" style="color:#FF4D4F;" @click="Deactivate(scope.row)">删除</span>
                <span   class="color_btns" style="margin-left:2rem;"  @click="addProClick(scope.row)">产品详情</span>
              </template>
          </el-table-column>
        </el-table>
        <div class="pagination">
          <!-- <span class="title_pag">已过期产品，禁止修改产品</span> -->
          <span class="demonstration">共{{data.total}}条记录，</span>
          <span class="demonstration">当前显示第{{data.page}}页</span>
          <el-pagination background layout="prev, pager, next"  @current-change="handleCurrentChange" :total="data.total" :page-size="data.page_size" :current-page="data.page"  ></el-pagination>
        </div>
    </div>
    <addPro v-if="addflow" ref="addpros" @proClose="proClose" @sucClick="sucClicks"></addPro>
  </div>
</template>
<script>
import addPro from '@/components/pro/add.vue'
import {MessageBox} from 'element-ui'
import {  getProductList , getProductType , deleteProduct , updateSort  } from '@/request/scenic.js'
export default {
  components: {
    addPro
  },
  data(){
    return{
      addflow:false,
      typeArr:[],
      tableData:[
      ],
      option:[
        {
          value:'1',
          label:'上线'
        },
        {
          value:'2',
          label:'下线'
        }
      ],
      multipleSelection:[],
      data:{
        page:1,
        page_size:8,
        total:0,
        token:window.sessionStorage.getItem('Token'),
        product_name:'',
        type_id:'',
        state:''
      },
    }
  },
  created(){
    let data = {
      token:window.sessionStorage.getItem('Token'),
    }
    getProductType(data).then(res=>{
      if(res.data.rcode==200){
        this.typeArr = res.data.result
      }
    })
    this.getList()
  },
  methods:{
    tableRowClassName({ row, rowIndex }) {
      let flow = this.ProDetaik(row)
      if(!flow){
        return "warning-row";
      }
    },
    ProDetaik(row){
      let times = window.sessionStorage.getItem('expires_in')
      let beijingTime = window.sessionStorage.getItem('beijingTime')  // 当前时间
      let old = row.signup_end ;                                     // 报名过期时间      
      const date1 = new Date(beijingTime);
      const date2 = new Date(old);
      const diff = date1.getTime() - date2.getTime();
      const news = Math.floor(diff / (1000 * 60 * 60));
      const olds = (times/60)/60 ;
      if(news>=olds){
        return false
      }else{
        return true
      }
    },
    sucClicks(){
      this.data.page = 1
      this.getList()
      this.addflow = false
    },
    handleCurrentChange(e){
      this.data.page = e
      this.getList()
    },
    batchBtns(){
      if(this.multipleSelection.length==0){
        this.$message.error('请选择上架产品')
        return false
      }
      MessageBox(`此操作将批量上架该产品, 是否继续?`, '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        let ids = ''
        this.multipleSelection.map(item=>{
          ids += item.id +','
        })
        ids = ids.substring(0, ids.length - 1);
        let data = {
            state:1,
            ids:ids,
            token:window.sessionStorage.getItem('Token'),
            scenicid:window.sessionStorage.getItem('scenicid'),
        }
        changeStateBatch(data).then(res=>{
          if(res.data.rcode=='200'){
            this.getList()
            this.$message.success('操作成功')
          }else{
            this.$message.error(res.data.msg)
          }
        })
      }).catch(() => {
                
      });
    },
    setup(i,row){
      let txt = ''
      if(i==1){
        txt = '上线'
      }else{
        txt = '下线'
      }
      MessageBox(`此操作将${txt}该产品, 是否继续?`, '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        let data = {
          state:i,
          ids:row,
          token:window.sessionStorage.getItem('Token'),
          scenicid:window.sessionStorage.getItem('scenicid'),
        }
        changeStateBatch(data).then(res=>{
          if(res.data.rcode=='200'){
            this.getList()
            this.$message.success('操作成功')
          }else{
            this.$message.error(res.data.msg)
          }
        })
      }).catch(() => {
                
      });
    },
    chaxun(){
      this.data.page = 1
      this.getList()
    },
    sortBlur(row){
      if(row.sort<0){
        this.$message.error('请输入大于0的整数')
        this.getList()
        return false
      }else{
        let num = /^[0-9]*$/.test(row.sort)
        if(num){
        }else{
          this.$message.error('请输入整数')
          this.getList()
          return false
        }
      }
      let data = {
        token:window.sessionStorage.getItem('Token'),
        sort:row.sort,
        id:row.id
      }
      updateSort(data).then(res=>{
        if(res.data.rcode=='200'){
          this.$message.success('排序成功')
          this.getList()
        }
      })
    },
    getList(){
      getProductList(this.data).then(res=>{
        if(res.data.rcode=='200'){
          console.log(res.data.result.data,res.data.result.total)
          this.tableData = res.data.result.data
          this.data.total = res.data.result.total
        }
      })
    },
    Deactivate(row){
      MessageBox(`是否删除该产品?`, "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      }).then(() => {
        let data = {
          id:row.id,
          token:window.sessionStorage.getItem('Token'),
        }
        deleteProduct(data).then(res=>{
          if(res.data.rcode=='200'){
            this.data.page = 1
            this.getList()
            this.$message.success('删除成功')
          }else{
            this.$message.error(res.data.msg)
          }
        })
      })
      .catch(() => {});
    },
    proClose(){
      this.addflow = false
    },
    Copys(row){
      row.states = 3
      this.addflow = true
      this.$nextTick(() => {
        this.$refs.addpros.seeInfo(row);
      });
    },
    addProClick(row){
      if(this.ProDetaik(row)){
        this.addflow = true
        row.states = 1 // 未过期产品
      }else{
        row.states = 2
        this.addflow = true  // 过期产品
      }
      this.$nextTick(() => {
        this.$refs.addpros.seeInfo(row);
      });
    },
      handleSelectionChange(val) {
        this.multipleSelection = val;
      },
     // 表头设置
     tableHeaderColor({ row, column, rowIndex, columnIndex }) {
      return this.utils.tableHeaderColor({
        row,
        column,
        rowIndex,
        columnIndex
      });
    },
    cellStyle({ row, rowIndex }) {
      return this.utils.cellStyle({
        row,
        rowIndex
      });
    }
  }
}
</script>
<style lang="less" scoped>
.pages{
  position: relative;
  height: 100%;
}
.main{
  position: relative;
}
.color_btns{
  color: #246DEB;
  font-size: 1.4rem;
  cursor: pointer;
}
.main{
  flex: 1;
  width: 100%;
  height: 100%;
  background: #fff;
  padding: 2rem;
  box-sizing: border-box;
  margin-top: 2rem;
  overflow: auto;
}
.main_filter{
    display: flex;
    align-items: center;
    justify-content: space-between;
    margin-bottom: 2rem;
    >div{
      display: flex;
      align-items: center;
      &:nth-child(1){
        >div{
          margin-right: 2rem;
        }
      }
      &:nth-child(2){
        >div{
          cursor: pointer;
          margin-left: 2rem;
          width: 9.2rem;
          height: 4rem;
          border: 1px solid #246DEB;
          display: flex;
          align-items: center;
          justify-content: center;
          border-radius: 0.4rem;
          img{
            margin-right: 0.8rem;
          }
          span{
            color: #246DEB;
            font-size: 1.4rem;
          }
        }
      }
    }
}
.filter_btns{
  display: flex;
  align-items: center;
  >div{
    height: 4rem;
    display: flex;
    justify-content: center;
    align-items: center;
    border-radius: 0.4rem;
    font-size: 1.4rem;
    background: #246DEB;
    color: #fff;
    cursor: pointer;
    width: 10rem;
    margin-right: 2rem;
  }
}
// 分页
.pagination {
  display: flex;
  justify-content: center;
  align-items: center;
  height: 32px;
  margin: 42px auto;
  position: relative;
  span {
    font-family: ".PingFang SC";
    font-style: normal;
    font-weight: 400;
    font-size: 14px;
    color: #000000;
  }
}
.pages{
  display: flex;
  flex-direction: column;
}
.lg_css{
  color: #B8B8B8;
  font-weight: 600;
  font-size: 1.4rem;
}
::v-deep  .el-table .warning-row .cell {
  color: #B8B8B8;
}

.flex_tui{
  display: flex;
  align-items: center;
  cursor: pointer;
  justify-content: center;
}
.product_divs{
  position: relative;
  height: 4.2rem;
  line-height: 4.2rem;
  img{
    position: absolute;
    width: 4.2rem;
    height: 4.2rem;
    left:1rem;
    transform: translate(-50%,0);
    z-index: 9;
  }
  .lg_css{
    margin-left: 2rem;
  }
}
.el-table {
  /deep/ .el-table__body-wrapper::-webkit-scrollbar {
      width: 10px; /*滚动条宽度*/
      height: 10px; /*滚动条高度*/
  }
  /*定义滚动条轨道 内阴影+圆角*/
  /deep/ .el-table__body-wrapper::-webkit-scrollbar-track {
      box-shadow: 0px 1px 3px #F5F5F5 inset; /*滚动条的背景区域的内阴影*/
      border-radius: 10px; /*滚动条的背景区域的圆角*/
      background-color: #F5F5F5; /*滚动条的背景颜色*/
  }
  /*定义滑块 内阴影+圆角*/
  /deep/ .el-table__body-wrapper::-webkit-scrollbar-thumb {
      box-shadow: 0px 1px 3px #246DEB inset; /*滚动条的内阴影*/
      border-radius: 10px; /*滚动条的圆角*/
      background-color: #246DEB; /*滚动条的背景颜色*/
  }
}
.title_pag{
  position: absolute;
  left: 0;
  top: 50%;
   transform: translate(0,-50%);
   color: red;
   font-size: 1.6rem;
}
</style>